import * as React from "react";
import { matchPath, useLocation } from "react-router-dom";
import { NotFoundPage } from "@/containers/NotFoundPage";
import { BackgroundLibraryPage } from "@/containers/Admin/Backgrounds/BackgroundLibraryPage";
import { DesignEditorPage, NewDesignPage, PromptStudioListPage } from "@/containers/Coach/PromptStudio";
import { PromptStudioScopeProvider } from "@/containers/Coach/PromptStudio/PromptStudioScope";
import { URLS } from "@/utils/routes";
import { useSocialCoachSession } from "@/utils/useSocialCoachSession";

export * from "@/containers/Coach/PromptStudio/PromptStudioScope";

function pageForPath(pathname: string): React.FC {
  // Before the editor: "/admin/prompt-studio/backgrounds" would otherwise read as a package id.
  if (matchPath(pathname, { path: URLS.admin.promptStudioBackgrounds, exact: true })) return BackgroundLibraryPage;
  if (matchPath(pathname, { path: URLS.admin.adminNewDesign, exact: true })) return NewDesignPage;
  if (matchPath(pathname, { path: URLS.admin.adminDesign, exact: true })) return DesignEditorPage;
  return PromptStudioListPage;
}

/** Wraps the Prompt Studio pages (and the admin-only background library) in the admin scope; non-admins get the 404 page. */
export const AdminPromptStudio: React.FC = () => {
  const { isAdmin } = useSocialCoachSession();
  const location = useLocation();

  if (!isAdmin) return <NotFoundPage />;

  const Page = pageForPath(location.pathname);
  return (
    <PromptStudioScopeProvider>
      <Page />
    </PromptStudioScopeProvider>
  );
};
